import Payment from "payment";


export const renderRating = (rating) => {
  let ratings = [];

  for (let i = 0; i <= rating; i++) {
    ratings.push(<div className='star'><img alt='' src='/homeProducts/star.svg' /></div>);
  }

  return ratings;
}

export const formatPrice = (price) => {
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return `${USDollar.format(price)}`;
}

export const formatDate = (dateString) => {
  const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', options);
};

const clearNumber = (value = "") => {
  return value.replace(/\D+/g, "");
}

export const formatCreditCardNumber = (value) => {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case "amex":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 15)}`;
      break;
    case "dinersclub":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
}

export const formatCVC = (value, prevValue, allValues = {}) => {
  const clearValue = clearNumber(value);
  let maxLength = 4;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
    maxLength = issuer === "amex" ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

export const formatExpirationDate = (value) => {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
}

export const formatFormData = (data) => {
  return Object.keys(data).map(d => `${d}: ${data[d]}`);
}

export const groupArrayInChunks = (array, chunkSize) => {
  return array.reduce((result, item, index) => {
    const chunkIndex = Math.floor(index / chunkSize);
    if (!result[chunkIndex]) {
      result[chunkIndex] = [];
    }
    result[chunkIndex].push(item);
    return result;
  }, []);
};

export const containsLiveEdge = (inputString) => {
  // Define a regular expression to match "Live Edge" with any case sensitivity and ignore special characters.
  const regex = /live\s*edge/i;

  // Test if the input string matches the pattern
  return regex.test(inputString);
}

export const getTableType = (inputString) => {
  // Define a regular expression to match "Dining Table" or "Coffee Table" with any case sensitivity and ignore extra spaces.
  const regex = /\b(dining\s*table|coffee\s*table)\b/i;

  // Use the match method to find the matched string
  const match = inputString.match(regex);

  // If a match is found, format it to "Capitalized Case" and return
  if (match) {
    return match[0]
      .toLowerCase() // Convert to lowercase first to ensure consistent formatting
      .split(' ') // Split the string into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' '); // Join the words back into a single string
  }

  // Return null if no match is found
  return null;
};

export const shuffleArray = (array) => {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
};

export const normalizeWords = (str) => {
  return str
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '') // remove punctuation
      .split(/\s+/)
      .filter(Boolean);
}

/**
 * Checks if a target string contains all or most words from a reference string.
 * @param {string} reference - The string containing key words to match.
 * @param {string} target - The string to search within.
 * @param {number} minMatchRatio - 1 = all words must match, 0.8 = 80% match allowed.
 * @returns {boolean}
 */
export const matches = (reference, target, minMatchRatio = 1) => {
  const refWords = normalizeWords(reference);
  const targetWords = normalizeWords(target);

  let matchesCount = 0;

  for (const refWord of refWords) {
      if (targetWords.some(tw => tw.includes(refWord) || refWord.includes(tw))) {
          matchesCount++;
      }
  }

  return matchesCount / refWords.length >= minMatchRatio;
}

export const createSlug = (title) => {
  return title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
      .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
};